import appRoutes from './routes';
import { createRouter, createWebHashHistory, Router } from 'vue-router';
import uiAfterEachGuard from '../core/router-guards/ui-after-each-guard';
import formsBeforeEachGuard from '../core/router-guards/forms-before-each-guard';
import beforeEachResolveGuard from '../core/router-guards/resolve-before-each-guard';
import breadcrumbAfterEachGuard from '../core/router-guards/breadcrumb-after-each-guard';
import permissionsBeforeEachGuard from '../core/router-guards/permissions-before-each-guard';

export function setupRouter(): Router {
  const router = createRouter({
    history: createWebHashHistory(),
    routes: appRoutes,
  });

  router.beforeEach(formsBeforeEachGuard);
  router.beforeEach(permissionsBeforeEachGuard);
  router.beforeEach(beforeEachResolveGuard);
  router.afterEach(uiAfterEachGuard);
  router.afterEach(breadcrumbAfterEachGuard);

  return router;
}
